import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, ListItemButton, Stack, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { paths } from 'routes';
import { isoToDateString } from 'utils/dateFormatter';

import { useMarkNotificationRead } from '../api/markRead';

export const NotificationItem = ({ notification, onOpen }) => {
  const navigate = useNavigate();
  const { mutate } = useMarkNotificationRead();
  const { notification_id, title, message, link, read_at, created_on } = notification;
  const unread = !read_at;

  const handleClick = () => {
    if (unread) mutate({ notificationID: notification_id });
    if (onOpen) onOpen();
    if (link) navigate(paths.notificationTarget(link));
  };

  return (
    <ListItemButton
      onClick={handleClick}
      sx={{ alignItems: 'flex-start', gap: 1.5, px: 2, py: 1.5, bgcolor: unread ? 'action.hover' : 'transparent' }}
    >
      <Box
        aria-hidden
        sx={{
          mt: 0.75,
          width: 8,
          height: 8,
          flexShrink: 0,
          borderRadius: '100%',
          bgcolor: unread ? 'error.light' : 'transparent',
        }}
      />
      <Stack gap={0.25} minWidth={0}>
        <Typography variant="body2" fontWeight={unread ? 700 : 500} sx={{ wordBreak: 'break-word' }}>
          {title}
          {unread && (
            <Box component="span" sx={visuallyHidden}>
              {' '}
              (unread)
            </Box>
          )}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
          {message}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {isoToDateString(created_on, true)}
        </Typography>
      </Stack>
    </ListItemButton>
  );
};
